import * as React from "react";

export default function Chromatogram(props) {

    React.useEffect(() => {
        // console.log("Creating graph...")
        // var data = [
        //     { time: 0, value: 0.5 },
        //     { time: 5, value: 0.6 },
        //     { time: 10, value: 0.7 },
        //     { time: 15, value: 0.8 },
        //     { time: 20, value: 0.9 }
        // ];
        // createGraph("#chromatogram-graph", data);
    }, []);

    return (
        <div className="">
            <h1>{props.analyte.name}</h1>
            <h1>{props.analyte.id}</h1>
            {/* <div className="bg-info" id="chromatogram-graph"></div> */}
        </div>
    )
}





